"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "340"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Client Name",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.lead.client.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Task"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(_vm.agendaLabels[scope.row.agenda] || scope.row.agenda) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Objective"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.comments || _vm.agendaLabels[scope.row.agenda] || scope.row.agenda) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Assign to",
      width: "160",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.assignedUser.fullName) + " "), _c("br"), _vm._v(" Due Dt.- " + _vm._s(_vm._f("moment")(scope.row.dueDate, "DD MMMM YYYY")) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Priority",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-tag", {
          attrs: {
            type: _vm.tagType[scope.row.priority]
          }
        }, [_vm._v(" " + _vm._s(scope.row.priority) + " ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;